var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { registerDecorator, ValidatorConstraint, } from 'class-validator';
import { isValid } from 'date-fns';
let IsFiltersConstraint = class IsFiltersConstraint {
    validate(value, args) {
        const schema = args.constraints[0];
        if (value === undefined) {
            return true;
        }
        if (typeof value !== 'object' || Array.isArray(value) || value === null) {
            return false;
        }
        return Object.keys(value).every((filterKey) => {
            const activeFilter = schema.find(({ key }) => key === filterKey);
            if (!activeFilter) {
                return false;
            }
            if (activeFilter.type === 'text' &&
                typeof value[filterKey] !== 'string') {
                return false;
            }
            if (activeFilter.type === 'select' &&
                !activeFilter.options.find(({ value: option }) => option === value[filterKey])) {
                return false;
            }
            if (activeFilter.type === 'multiple' &&
                (!Array.isArray(value[filterKey]) ||
                    value[filterKey].some((activeOption) => typeof activeOption !== 'string' ||
                        !activeFilter.options.find(({ value: option }) => option === activeOption)))) {
                return false;
            }
            if (activeFilter.type === 'bool' &&
                typeof value[filterKey] !== 'boolean') {
                return false;
            }
            if (activeFilter.type === 'timerange') {
                if (!(typeof value[filterKey] === 'object' &&
                    value[filterKey] !== null &&
                    !Array.isArray(value[filterKey]))) {
                    return false;
                }
                const subValue = value[filterKey];
                const start = subValue.start;
                const end = subValue.end;
                if ((end && !isValid(new Date(end))) ||
                    (start && !isValid(new Date(start)))) {
                    return false;
                }
            }
            return true;
        });
    }
    defaultMessage(args) {
        return `${args.property} are not valid filters`;
    }
};
IsFiltersConstraint = __decorate([
    ValidatorConstraint({ name: 'IsFilters' })
], IsFiltersConstraint);
export { IsFiltersConstraint };
export function IsFilters(filters, validationOptions) {
    return (object, propertyName) => {
        registerDecorator({
            target: object.constructor,
            propertyName,
            options: validationOptions,
            constraints: [filters],
            validator: IsFiltersConstraint,
        });
    };
}
